import { createEditionFormatter } from '@/lib/editionFormatter';
import { AppEdition } from '@/shared/appEdition';

const formatDanishIdentityNumber = (cprNumber: string): string => {
    const cleaned = cprNumber.replace(/\s+/g, '');
    return cleaned.slice(0, 6) + '-' + cleaned.slice(6);
};

const formatNorwegianIdentityNumber = (nationalIdentifier: string): string =>
    nationalIdentifier.replace(/\s+/g, '');

export const formatNationalIdentityNumber = createEditionFormatter({
    [AppEdition.Denmark]: formatDanishIdentityNumber,
    [AppEdition.Norway]: formatNorwegianIdentityNumber,
});
